import React, { useState } from "react";
import ImportData from "./ImportData";
import Csvimport from "./Csvimport";
import MultiStepImport from "./MultiStepImport";
import { Grid, Button, Box } from "@mui/material";
import "../../Styles/ImportData.css";
import "../../Styles/PromotionsWorkspace.css";
import { useAuthDetails } from "../../Common/cookiesHelper";

const MainImportData = () => {
  const [useMultiStep, setUseMultiStep] = useState(true); // Toggle between old and new import
  const { LoginGetDashBoardRecordJson } = useAuthDetails();
  const is_superadmin_login = LoginGetDashBoardRecordJson?.login_type;

  return (
    <div className="qv-import-data-workspace">
      <Grid
        container
        sx={{ py: 2.5, mt: 3.6 }}
        className="box_shadow_div qv-import-data-header"
      >
        <Grid item xs={12} sx={{ px: { xs: 1, sm: 2.5 } }}>
          <Grid container>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h1 style={{ marginBottom: 0 }} className="heading qv-import-data-title">
                  Import Product Data
                </h1>
                {is_superadmin_login  === "superadmin"? (
                    <Button
                        className="qv-import-data-toggle"
                        variant="outlined"
                        size="small"
                        onClick={() => setUseMultiStep(!useMultiStep)}
                        sx={{ ml: 2 }}
                    >
                        {useMultiStep ? 'Switch to Simple Import' : 'Switch to Advanced Import'}
                    </Button>
                ) : null}
               
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {useMultiStep ? (
        <div className="q-order-main-page">
          <MultiStepImport />
        </div>
      ) : (
        <>
          <div className="q-order-main-page">
            <ImportData />
          </div>
          <div className="q-order-main-page">
            <Csvimport />
          </div>
        </>
      )}
    </div>
  );
};

export default MainImportData;
